<div class="container" *ngIf='webinars$ | async as webinars'>
  <!-- section title -->
  <h2 class="section-title wow fadeInUp">{{ 'sections.webinars.title' | translate }}</h2>

  <div class="spacer-60"></div>

  <div class="row webinar-wrapper">
    <div class="col-sm-4 col-md-4 col-lg-12" *ngFor='let webinar of webinars.reverse()'>
      <kdn-webinar
        [webinar]='webinar'
      >
      </kdn-webinar>
      <div class="spacer-20"></div>
    </div>
  </div>
</div>
